import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  villas: [],
};

export const villasSlice = createSlice({
  name: "villas",
  initialState,
  reducers: {
    storeVillas: (state, { payload }) => {
      state.villas = payload;
    },
  },
});

export const { storeVillas } = villasSlice.actions;

export default villasSlice.reducer;
